export enum ResponseState {
  IDLE = 'idle',          // Same as input, but don't autofocus
  INPUT = 'input',
  LOADING = 'loading',
  COMPLETE = 'complete',
}
